import accordion, { accordionVariants, AccordionType } from './accordion';
import alert, { alertVariants, AlertVariantsType } from './alert-banner';
import buttonSizes, { buttonSizesVariants, ButtonSizesVariantsType } from './button-sizes';
import buttons, { buttonVariants, ButtonVariantsType } from './buttons';
import card, { cardVariants, CardVariantsType } from './cards';
import featureGrid, { featureGridVariants, FeatureGridVariantsType } from './feature-grid';
import form, { formVariants, FormType } from './form';
import hero, { heroVariants, HeroType } from './hero';
import headings, { headingVariants, HeadingsVariantType } from './headings';
import links, { linkVariants, LinkVariantsType } from './links';
import modal, { modalVariants, ModalVariantsType } from './modal';
import nav, { navVariants, NavType } from './nav';
import navbar, { navbarVariants, NavbarType } from './navbar';
import paper, { paperVariants, PaperVariantsType } from './paper';
import quote, { quoteVariants, QuoteVariantsType } from './quote';
import tileSizes, { tileSizesVariants, TileSizesVariantsType } from './tile-sizes';
import videoPlayer, { videoPlayerVariants, VideoPlayerVariantsType } from './video-player';
import wave, { waveVariants, WaveVariantsType } from './wave';

export const componentVariants = {
  accordion: accordionVariants,
  alert: alertVariants,
  buttonSizes: buttonSizesVariants,
  buttons: buttonVariants,
  card: cardVariants,
  featureGrid: featureGridVariants,
  form: formVariants,
  headings: headingVariants,
  hero: heroVariants,
  links: linkVariants,
  modal: modalVariants,
  nav: navVariants,
  navbar: navbarVariants,
  paper: paperVariants,
  quote: quoteVariants,
  tileSizes: tileSizesVariants,
  videoPlayer: videoPlayerVariants,
  wave: waveVariants
};

export interface Components {
  /** The Accordion component types. */
  Accordion: AccordionType;
  /** The AlertBanner component types. */
  AlertBanner: AlertVariantsType;
  /** The Button sizes component types. */
  ButtonSizes: ButtonSizesVariantsType;
  /** The Button component types. */
  Button: ButtonVariantsType;
  /** The Card component types. */
  Card: CardVariantsType;
  /** The Feature Grid component types. */
  FeatureGrid: FeatureGridVariantsType;
  /** The Form component types. */
  Form: FormType;
  /** The Heading component types. */
  Heading: HeadingsVariantType;
  /** The Hero component types. */
  Hero: HeroType;
  /** The Link component types. */
  Link: LinkVariantsType;
  /** The Modal component types. */
  Modal: ModalVariantsType;
  /** The Nav component types. */
  Nav: NavType;
  /** The Navbar component types. */
  Navbar: NavbarType;
  /** The Paper component types. */
  Paper: PaperVariantsType;
  /** The Quote component types. */
  Quote: QuoteVariantsType;
  /** The Tile size component types. */
  TileSize: TileSizesVariantsType;
  /** The VideoPlayer component types. */
  VideoPlayer: VideoPlayerVariantsType;
  /** The Wave component types. */
  Wave: WaveVariantsType;
}

export {
  alert,
  accordion,
  buttonSizes,
  buttons,
  quote,
  card,
  featureGrid,
  form,
  headings,
  hero,
  links,
  modal,
  nav,
  navbar,
  paper,
  tileSizes,
  videoPlayer,
  wave
};
